export default {
  methods: {
    /*
     点击filter组件里的查询按钮触发的查询动作
    */
    queryByFilter() {
      this.filter.val = { ...this.filter.model };
      if (this.page) {
        this.page.num = 1;
      }
      this.query();
    },

    /*
     点击页码触发的查询动作
    */
     queryByPageNum(num) {
      this.page.num = num;
      this.query();
    },

    /*
     选中pagesize触发的查询动作
    */
     queryByPageSize(size) {
      this.page.size = size;
      this.query();
    },

    /*
     清空filter组件各个控件的值
    */
    resetModel() {
      this.filter.model = this.getFilterVal(this.filter.fields);
      this.queryByFilter();
    },
  }
}